import GameStepBase from '../../game_step_base';
import GameWindowComponentController from '../../../../../components/game_window_component/game_window_component_controller';

export default class BuildGameWindowGameStep extends GameStepBase {
    static CLASS = 'BuildGameWindowGameStep';
    private _isReal: boolean;

    init(params) {
        super.init(params);
        this._isReal = params.isReal;
    }

    run(gameOptions) {

        let gameWindow = GameWindowComponentController.create({
            isReal: this._isReal,
            gameType: gameOptions.gameType,
            gameSize: gameOptions.gameSize,
            isResizable: gameOptions.isResizable,
            navigationBar: gameOptions.gameNavigationBar,
            regulationStripe: gameOptions.gameRegulationStripe,
            gameBody: gameOptions.gameBody,
            gameBackgroundImage: this.serviceFactory.gameService().resolveGameImagePath(gameOptions.gameInfo.images && gameOptions.gameInfo.images.background),
            isFreePlay: gameOptions.freePlayData? true : false,
        });

        return Promise.resolve(Object.assign(gameOptions, {
            gameWindow: gameWindow
        }));
    }
}
